export const zDesktopBanner = 2;
export const zFormNewSignalSelect = 3;
export const zHeaderNotifications = 4;
export const zDesktopFormDropdown = 1;
export const zDesktopNetworkSwitcher = 1;
export const zSanNavigationPopup = 4;
export const zCookiesBannerMoreThenIntercom = 2147483005;

export const zMobileHeader = 1;

export const zModalsWr = 999;
export const zNotifications = 9_999;
export const zHoverTooltip = 9_999;
export const zWeb3Modal = 10_000;
